import { render, staticRenderFns } from "./EntityManagement.vue?vue&type=template&id=96dfc714"
import script from "./EntityManagement.vue?vue&type=script&lang=js"
export * from "./EntityManagement.vue?vue&type=script&lang=js"
import style0 from "./EntityManagement.vue?vue&type=style&index=0&id=96dfc714&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports